<span
  *ngIf="isSpeechSupported && !isListening"
  (mousedown)="$event.preventDefault()"
  (click)="start()"
  class="material-icons mic-btn"
  [class.is-disabled]="disabled"
  [title]="microphoneAccessDenied ? 'Microphone access denied' : 'Dictate'">
  {{ microphoneAccessDenied ? 'mic_off' : 'mic' }}
</span>
<span
  *ngIf="isSpeechSupported && isListening"
  (mousedown)="$event.preventDefault()"
  (click)="stop()"
  class="stop-btn"
  title="Stop dictating">
  <span class="stop-btn__icon"></span>
</span>
